(function () {
  'use strict';

  function parseTimerDate(value) {
    if (!value) return null;

    var normalized = value.trim();
    if (!normalized) return null;

    if (/^\d{4}-\d{2}-\d{2} \d{1,2}:\d{2}(:\d{2})?$/.test(normalized)) {
      normalized = normalized.replace(' ', 'T');
    }

    if (/^\d{4}-\d{2}-\d{2}T\d{1,2}:\d{2}$/.test(normalized)) {
      normalized += ':00';
    }

    var parsed = new Date(normalized);
    return isNaN(parsed.getTime()) ? null : parsed.getTime();
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function initTimer(timer) {
    var timerDate = timer.querySelector('[data-timer-date]');
    if (!timerDate) return;

    var target = parseTimerDate(timerDate.dataset.time);
    var content = timer.querySelector('.timer-content');
    var message = timer.querySelector('.timer-content-messsage');
    var hoursEl = timer.querySelector('.last_chance_bar__inner__hours');
    var minsEl = timer.querySelector('.last_chance_bar__inner__mins');
    var secsEl = timer.querySelector('.last_chance_bar__inner__secs');

    if (!target || !hoursEl || !minsEl || !secsEl) {
      if (content) content.style.display = 'none';
      return;
    }

    function complete() {
      hoursEl.textContent = '00';
      minsEl.textContent = '00';
      secsEl.textContent = '00';
      if (content) content.style.display = 'none';
      if (message) message.style.display = '';
    }

    function tick() {
      var distance = target - Date.now();

      if (distance <= 0) {
        complete();
        if (interval) clearInterval(interval);
        return;
      }

      var hours = Math.floor(distance / 3600000);
      var minutes = Math.floor((distance % 3600000) / 60000);
      var seconds = Math.floor((distance % 60000) / 1000);

      hoursEl.textContent = pad(hours);
      minsEl.textContent = pad(minutes);
      secsEl.textContent = pad(seconds);
    }

    var interval = null;
    tick();
    if (target > Date.now()) {
      interval = setInterval(tick, 1000);
    }
  }

  function initTimers() {
    document.querySelectorAll('[data-custom-timer]').forEach(initTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimers);
  } else {
    initTimers();
  }
})();